import { render, staticRenderFns } from "./AdminProductTemplatesEditScreen.vue?vue&type=template&id=6a453ebb&scoped=true&"
import script from "./AdminProductTemplatesEditScreen.vue?vue&type=script&lang=js&"
export * from "./AdminProductTemplatesEditScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a453ebb",
  null
  
)

export default component.exports